import React from 'react'
import PropTypes from 'prop-types'

const SubscribeHead = props => {
  return (
    <select
      className="filter-header text-uppercase"
      onChange={props.setFilterValue(
        'subscriptionPlan',
        props.profile.filter,
        props.profile.sort
      )}
    >
      <option className="text-uppercase" value="">
        subscription
      </option>
      <option className="text-uppercase" value="free">
        free
      </option>
      {props.subscription.map((plan, index) => (
        <option className="text-uppercase" value={plan.id} key={index}>
          {plan.name}
        </option>
      ))}
    </select>
  )
}

SubscribeHead.defaultProps = {
  subscription: [],
}

SubscribeHead.propTypes = {
  profile: PropTypes.shape({
    filter: PropTypes.string.isRequired,
    sort: PropTypes.string.isRequired,
  }).isRequired,
  setFilterValue: PropTypes.func.isRequired,
  subscription: PropTypes.shape,
}

export default SubscribeHead
